// src/config/chainConfig.js
import telosLogo from '../assets/telos.png';
import xprLogo from '../assets/xpr.png';

const chainConfig = {
  'telos-mainnet': {
    name: 'TELOS',
    chainId: '4667b205c6838ef70ff7988f6e8257e8be0e1284a2f59699054a018f743b1d11',
    rpcEndpoints: [
      {
        protocol: 'https',
        host: 'mainnet.telos.net',
        port: 443,
      }
    ],
    symbol: 'TLOS',
    precision: 4,
    blockExplorerUrl: 'https://explorer.telos.net',
    chainFamily: 'TELOS',
    token: 'TLOS',
    logo: telosLogo,
    subdomain: 'telos',
    maxVotes: 30 // máximo de productores por voto
  },
  'xpr-mainnet': {
    name: 'XPR',
    chainId: '384da888112027f0321850a169f737c33e53b388aad48b5adace4bab97f437e0',
    rpcEndpoints: [
      {
        protocol: 'https',
        host: 'proton-api.eosiomadrid.io',
        port: 443,
      }
    ],
    symbol: 'XPR',
    precision: 4,
    blockExplorerUrl: 'https://explorer.xprnetwork.org',
    chainFamily: 'XPR',
    token: 'XPR',
    logo: xprLogo,
    subdomain: 'xpr',
    maxVotes: 4 // máximo de productores por voto
  },
  'telos-testnet': {
    name: 'TELOS Testnet',
    chainId: '1eaa0824707c8c16bd25145493bf062aecddfeb56c736f6ba6397f3195f33c9f',
    rpcEndpoints: [
      {
        protocol: 'https',
        host: 'testnet.telos.net',
        port: 443,
      }
    ],
    symbol: 'TLOS',
    precision: 4,
    blockExplorerUrl: 'https://testnet.telos.net/v2/explore',
    chainFamily: 'TELOS',
    token: 'TLOS',
    logo: telosLogo,
    subdomain: 'telos-testnet',
    maxVotes: 30 // máximo de productores por voto
  },
  'xpr-testnet': {
    name: 'XPR Testnet',
    chainId: '71ee83bcf52142d61019d95f9cc5427ba6a0d7ff8accd9e2088ae2abeaf3d3dd',
    rpcEndpoints: [
      {
        protocol: 'https',
        host: 'proton-api-testnet.eosiomadrid.io',
        port: 443,
      }
    ],
    symbol: 'XPR',
    precision: 4,
    blockExplorerUrl: 'https://testnet.explorer.xprnetwork.org',
    chainFamily: 'XPR',
    token: 'XPR',
    logo: xprLogo,
    subdomain: 'xpr-testnet',
    maxVotes: 4 // máximo de productores por voto
  }
};

export const getChainConfig = (chainId) => {
  const config = chainConfig[chainId];
  if (!config) {
    throw new Error(`No configuration found for chain: ${chainId}`);
  }
  return config;
};

export default chainConfig;
